//#region Imports and Global Definitions
import React, { useState } from 'react';
import { SafeAreaView } from 'react-native';
var _ = require('lodash');
import { useTranslation } from 'react-i18next';
import { useHRAdminEmployees } from '../../../../hooks/useHRAdminEmployees';
import { ActivityIndicator } from 'react-native-paper';
import { showMessage } from 'react-native-flash-message';
import HRAdminAuthorizationForm from './HRAdminAuthorizationForm';
//#endregion

const HRAdminEmplAuthorizations = (props) => {
    //#region Const Definitions
    const { t } = useTranslation();
    const [isCompaniesLoading, setIsCompaniesLoading] = useState(false);
    const [errorMsg, setErrorMessage] = useState("")
    const [rules, setRules] = useState([]);
    const { postEmplAuth } = useHRAdminEmployees();
    //#endregion

    //#region Listeners
    const onSubmit = data => {
        setIsCompaniesLoading(true)
        let rulesData = []
        rules.forEach(rule => {
            rulesData.push(rule);
        });

        const specificEmployees = data?.['specificEmployeesAdded'];
        const excludedEmployees = data?.['excludedEmployees'];
        postEmplAuth(specificEmployees, rulesData, excludedEmployees, props.employee.employeeID).then((res) => {
            if (res.status === 200) {
                props.changeStep && props.changeStep();
            }
            else showMessage({
                message: t('common:issueMessage'),
                type: "error",
                duration: 3000,
            })
            setIsCompaniesLoading(false)
        }).catch((error) => {
            setIsCompaniesLoading(false)
            showMessage({
                message: t('common:issueMessage'),
                type: "error",
                duration: 3000,
            })
        })
    };
    //#endregion

    //#region Loading
    if (isCompaniesLoading) {
        return (
            <SafeAreaView
                style={{ justifyContent: 'center' }}>
                <ActivityIndicator animating={true} size='large' color="#86BC25" />
            </SafeAreaView>
        )
    }
    //#endregion

    return (
        <HRAdminAuthorizationForm
            employee={props.employee}
            isTrnParticipants={false}
            setErrorMessage={setErrorMessage}
            onSubmit={onSubmit}
            rules={rules}
            setRules={setRules}
        />
    )
};

export default HRAdminEmplAuthorizations;